export default {"src":"/_next/static/media/facebook-icon.0cc394c5.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};